import osl from "./assets/images/osl.png";
import spicejet from "./assets/images/spicejet.png";
export const data = {
  "banner": {
    "name": "Aditya Shrivastava",
    "position": ["Sr. Software Developer"]
  },
  "education": [
    {
      "degree": "Bachelor of Technology",
      "address": "Bhopal (M.P.)",
      "year": "2019",
      "name": "RGPV University"
    },
    {
      "degree": "Senior Secondary School Certificate",
      "address": "Raigarh (C.G.)",
      "year": "2015",
      "name": "Natwar H.Sec School"
    },
    {
      "degree": "Secondary School Certificate",
      "address": "Raigarh (C.G.)",
      "year": "2012",
      "name": "O.P. Jindal School"
    }
  ],
  "job": [
    {
      "position": "Senior Executive",
      "location": "Gurgaon",
      "company": "Spicejet",
      "image": spicejet,
      "year": "2025 - Present",
      "responsibilities": [
        "Owned and delivered critical booking, payment, and post-booking (MMB) experiences across SpiceJet's iOS, Android, Web, and backend platforms, directly impacting customer conversion and journey completion.",
        "Spearheaded React Native upgrades and platform modernization initiatives, ensuring uninterrupted service during major Android and iOS compliance migrations.",
        "Refactored legacy class-based components into a modern architecture, improving code maintainability, scalability",
        "Contributed to applications serving millions of travelers annually, balancing rapid feature delivery with the reliability requirements of a business-critical aviation platform. ",
        "Led technical reviews, mentored developers, and drove engineering best practices to improve code quality, release stability, and team productivity.",
      ]
    },
    {
      "position": "Sr. Software Developer",
      "location": "Delhi",
      "company": "Opensense Labs",
      "image": osl,
      "year": "2024 - 2025",
      "responsibilities": [
        "Led an agile team of 5+ JavaScript developers, managing sprints and training.",
        "Built scalable web apps using React.js, TypeScript, Next.js, and Node.js.",
        "Integrated AWS services (SQS, Lambda, Serverless), reducing server load by 30%.",
        "Enhanced user experience by identifying and resolving website issues, leading to a 70% reduction in reported problems.",
        "Developed multi-tenant SaaS apps with smooth navigation and secure auth.",
        "Created internal tools: JIRA automation tool & Chrome-based work log tracker.",
        "Conducted code reviews and mentored junior developers."
      ]
    },
    {
      "position": "Software Developer",
      "location": "Delhi",
      "company": "Opensense Labs",
      "image": osl,
      "year": "2021 - 2024",
      "responsibilities": [
        "Designing, developing, deploying, and maintaining web applications for both internal and client use.",
        "Write well-structured, reusable, and efficient code in React.js and Next.js.",
        "Developed the complete application management system like CMS on React.",
        "Built the frontend of a US client's website using Javascript and also built the AI chatbot in it using React JS.",
        "Optimized Elasticsearch queries, reducing latency by 50% and improving performance.",
        "Optimized the Drupal app by reducing deployment time by 40% and improving performance.",
        "Integrated Stripe payment gateway using Node.js and React, streamlining transaction processing."
      ]
    }
  ],
  "projects": [
    {
      "name": "Apply Once",
      "about": "Apply Once is a single-access education portal that brings together students, institutions, financial aid providers, agents, and employers and guides students all the way from courses to career opportunities."
    }
  ]
}
